import { Component } from '@angular/core';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  lang: any = localStorage.getItem('currentlang');
  policies: Array<any> = [
    {
      navName: 'terms',
      link: '/assets/documents/XRP20_Terms_of_Use.pdf',
    },
    {
      navName: 'privacy',
      link: '/assets/documents/XRP20_Privacy_Policy.pdf',
    },
    {
      navName: 'cookies',
      link: '/assets/documents/XRP20_Cookies_Policy.pdf',
    },
    {
      navName: 'audit',
      link: '/assets/documents/audit.pdf',
    },
  ];

  navigations: Array<any> = [
    {
      routeName: 'about',
      navName: 'nav_about',
    },
    {
      routeName: 'how-to-buy',
      navName: 'nav_howtobuy',
    },
    {
      routeName: 'roadmap',
      navName: 'nav_roadmap',
    },
    {
      routeName: 'faqs',
      navName: 'nav_faq',
    },
  ];

  constructor(private eventService: EventService) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
  }

  navigateToSection(section: string) {
    if (section) {
      window.location.hash = section;
      window.location.pathname = '/' + this.lang;
    }
  }
}
